var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.594 9c.89 0 1.312 1.078.703 1.688l-4.594 4.593a.94.94 0 0 1-1.406 0l-4.594-4.594C6.047 10.079 6.516 9 7.406 9H9V3.984C9 3.47 9.469 3 9.984 3h4.032c.515 0 .984.469.984.984V9zM5.016 18.984A.99.99 0 0 1 6 18h12a.99.99 0 0 1 .984.984c0 .563-.422 1.032-.984 1.032H6c-.562 0-.984-.47-.984-1.032"
  })));
};
export default SvgDownload;